<template>
  <div class="download-page">
    <div class="download-container">
      <!-- 加载状态 -->
      <div v-if="loading" class="loading">
        <div class="spinner"></div>
        <p>正在识别设备...</p>
      </div>

      <!-- 微信内打开 -->
      <div v-else-if="isWeChat" class="wechat-tip">
        <div class="platform-icon">📱</div>
        <h2>请在浏览器中打开</h2>
        <div class="tip-card">
          <p class="tip-text">
            点击右上角 <span class="menu-icon">⋯</span>
            选择"在浏览器打开"
          </p>
          <div class="guide-steps">
            <div class="step">
              <span class="step-num">1</span>
              <span>点击右上角菜单</span>
            </div>
            <div class="step">
              <span class="step-num">2</span>
              <span>选择"在浏览器打开"</span>
            </div>
          </div>
        </div>

        <div class="guide-illustration">
          <div class="phone-frame">
            <div class="status-bar"></div>
            <div class="browser-header">
              <span></span>
              <span>...</span>
            </div>
            <div class="browser-content">
              <div class="qr-placeholder"></div>
            </div>
          </div>
          <div class="guide-arrow">👇</div>
        </div>
      </div>

      <!-- 手机浏览器 -->
      <div v-else class="mobile-download">
        <h2>{{ appName }}</h2>
        <p>正在下载中...请在下载中查看 </p>
        <p>版本号：{{ version }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { post } from '@/utils/http';
import { message } from 'ant-design-vue';

export default {
  name: 'downloadApp',
  data() {
    return {
      // 加载状态
      loading: true,

      // 下载状态
      downloading: false,
      downloadProgress: 0,
      downloadTimer: null,

      // 下载链接
      downloadLinks: '',
      appName: '',
      version: '',

    };
  },

  computed: {
    // 是否微信
    isWeChat() {
      return navigator.userAgent.toLowerCase().match(/micromessenger/i) !== null;
    },

    // 是否移动设备
    isMobile() {
      return /android|harmonyos|harmony|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase())
    },

    // 是否手机浏览器
    isMobileBrowser() {
      return this.isMobile && !this.isWeChat;
    },

    // 是否电脑
    isPC() {
      return !this.isMobile;
    },

    // 设备型号
    deviceModel() {
      const ua = navigator.userAgent.toLowerCase();
      if (ua.indexOf('iphone') > -1) return 'iPhone';
      if (ua.indexOf('ipad') > -1) return 'iPad';
      if (/harmonyos|harmony/i.test(ua)) return 'HarmonyOS';
      if (ua.indexOf('android') > -1) {
        const match = ua.match(/android\s([0-9.]+)/);
        return match ? `Android ${match[1]}` : 'Android';
      }
      return '移动设备';
    },
  },

  methods: {
    // 下载App
    downloadApp(platform) {
      this.downloading = true;
      this.downloadProgress = 0;

      this.downloadTimer = setInterval(() => {
        if (this.downloadProgress >= 100) {
          clearInterval(this.downloadTimer);

          if (platform === 'android') {
            window.location.href = this.downloadLinks;
          } else {
            window.location.href = this.downloadLinks;
          }

          setTimeout(() => {
            this.downloading = false;
            this.downloadProgress = 0;
          }, 500);
        } else {
          this.downloadProgress += 10;
        }
      }, 200);
    },



    // 自动跳转（可选）
    autoRedirect() {
      window.location.href = this.downloadLinks;
    },

    async fetchDownloadLinks() {
      this.loading = true;

      var osType = 0;
      const ua = navigator.userAgent.toLowerCase();
      if (ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1) {
        osType = 0;
      } else {
        osType = 1;
      }

      try {
        post("/infrastructure-certificate/extend/appManager/getLatestPublishByAppAndOs", {
          osType,

          appId: this.$route.query.appId,
          envLabel: this.$route.query.envLabel,
        }).then((res) => {
          if ((res.url || '').length > 0) {
            this.downloadLinks = res.url || '';
            this.appName = res.appName || '';
            this.version = res.version || '';
            this.autoRedirect();
          } else {
            message.error('获取下载链接失败，请稍后再试');
          }
        });
        // // 获取App下载信息
        // const response = await axios.get(`${this.apiUrl}/api/v1/app/download-info`, {
        //   params: {
        //     appId: this.appId,
        //     platform: this.isMobileBrowser ? (this.deviceModel.includes('iPhone') ? 'ios' : 'android') : 'all',
        //     timestamp: Date.now() // 防止缓存
        //   },
        //   timeout: 10000 // 10秒超时
        // });

        // if (response.data && response.data.code === 0) {
        //   const data = response.data.data

        //   // 更新下载链接
        //   this.downloadLinks = {
        //     android: data.android?.downloadUrl || '',
        //     ios: data.ios?.downloadUrl || ''
        //   };


        //   // 根据设备自动跳转（可选）
        //   this.autoRedirect();
        // } else {
        //   throw new Error(response.data?.message || '获取下载信息失败');
        // }
      } catch (error) {
        message.error('获取下载链接失败，请稍后再试');
      } finally {
        this.loading = false;
      }
    },
  },

  mounted() {
    // 模拟加载配置
    // setTimeout(() => {
    //   this.loading = false;
    // }, 800);
    this.fetchDownloadLinks();
  },

  beforeDestroy() {
    // 清除定时器
    if (this.downloadTimer) {
      clearInterval(this.downloadTimer);
    }

    // 移除键盘事件监听
  },
};
</script>

<style scoped>
.download-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.download-container {
  background: white;
  border-radius: 24px;
  padding: 40px 30px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  max-width: 420px;
  width: 100%;
  text-align: center;
  position: relative;
  overflow: hidden;
}

/* 加载动画 */
.loading {
  text-align: center;
  color: #333;
  padding: 40px 0;
}

.spinner {
  width: 50px;
  height: 50px;
  margin: 0 auto 20px;
  border: 3px solid #f3f3f3;
  border-radius: 50%;
  border-top-color: #667eea;
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* 平台图标 */
.platform-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  color: white;
  box-shadow: 0 10px 20px rgba(102, 126, 234, 0.3);
}

/* 标题样式 */
h2 {
  color: #333;
  font-size: 26px;
  margin-bottom: 10px;
  font-weight: 600;
}

/* 微信提示样式 */
.wechat-tip {
  animation: fadeIn 0.5s ease;
}

.tip-card {
  background: #f8f9fa;
  border-radius: 16px;
  padding: 20px;
  margin: 20px 0;
}

.tip-text {
  font-size: 16px;
  color: #666;
  margin-bottom: 15px;
  line-height: 1.8;
}

.menu-icon {
  background: #333;
  color: white;
  padding: 4px 12px;
  border-radius: 8px;
  font-size: 18px;
  font-weight: bold;
}

.guide-steps {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.step {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.step-num {
  width: 24px;
  height: 24px;
  background: #667eea;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
}

.guide-illustration {
  margin-top: 30px;
  position: relative;
}

.phone-frame {
  background: #1a1a1a;
  border-radius: 24px;
  padding: 10px;
  max-width: 200px;
  margin: 0 auto;
}

.status-bar {
  height: 20px;
  background: #333;
  border-radius: 10px 10px 0 0;
}

.browser-header {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  background: #f5f5f5;
  border-radius: 8px 8px 0 0;
}

.browser-content {
  background: white;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0 0 8px 8px;
}

.qr-placeholder {
  width: 50px;
  height: 50px;
  background: #ddd;
  border-radius: 8px;
}

.guide-arrow {
  font-size: 30px;
  margin-top: 10px;
  animation: bounce 1s infinite;
}

@keyframes bounce {

  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(10px);
  }
}

/* 手机下载样式 */
.mobile-download {
  animation: fadeIn 0.5s ease;
}

.device-info {
  color: #667eea;
  font-size: 14px;
  margin-bottom: 20px;
  padding: 5px 10px;
  background: #f0f3ff;
  border-radius: 20px;
  display: inline-block;
}

.button-group {
  display: flex;
  gap: 15px;
  margin: 25px 0;
}

.btn-android,
.btn-ios {
  flex: 1;
  padding: 16px 10px;
  border: none;
  border-radius: 14px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  position: relative;
  overflow: hidden;
}

.btn-android {
  background: #3ddc84;
  color: #073042;
}

.btn-ios {
  background: #000;
  color: white;
}

.btn-android:hover:not(:disabled),
.btn-ios:hover:not(:disabled) {
  transform: translateY(-3px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

.btn-android:disabled,
.btn-ios:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.icon {
  font-size: 24px;
}

.btn-text {
  font-size: 15px;
}

.btn-size {
  font-size: 12px;
  opacity: 0.8;
}

/* 下载进度 */
.download-progress {
  margin: 20px 0;
}

.progress-bar {
  height: 6px;
  background: #f0f0f0;
  border-radius: 3px;
  overflow: hidden;
  margin-bottom: 10px;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #667eea, #764ba2);
  transition: width 0.3s ease;
}

/* App信息 */
.app-info {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 15px;
  margin: 20px 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

.info-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.info-label {
  font-size: 12px;
  color: #999;
  margin-bottom: 5px;
}

.info-value {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

/* 更多选项 */
.more-options {
  display: flex;
  justify-content: center;
  gap: 15px;
  font-size: 14px;
}

.more-link {
  color: #667eea;
  cursor: pointer;
  transition: color 0.2s;
}

.more-link:hover {
  color: #764ba2;
  text-decoration: underline;
}

.divider {
  color: #ddd;
}

/* PC下载样式 */
.pc-download {
  animation: fadeIn 0.5s ease;
}

.scan-tip {
  color: #666;
  margin-bottom: 20px;
}

.qrcode-tabs {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 20px;
}

.tab-item {
  padding: 8px 20px;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 14px;
  color: #666;
  background: #f0f0f0;
}

.tab-item.active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.qrcode-container {
  margin: 20px auto;
}

.qrcode-wrapper {
  width: 200px;
  height: 200px;
  margin: 0 auto;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 20px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
}

.qrcode-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.qrcode-tip {
  margin-top: 10px;
  font-size: 14px;
  color: #667eea;
  font-weight: 500;
}

.download-links {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin: 25px 0;
}

.link-item {
  color: #667eea;
  text-decoration: none;
  font-size: 14px;
  padding: 8px 15px;
  background: #f0f3ff;
  border-radius: 20px;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 5px;
}

.link-item:hover {
  background: #667eea;
  color: white;
}

.scan-stats {
  font-size: 13px;
  color: #999;
}

/* 底部文案 */
.footer-note {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
  font-size: 12px;
  color: #999;
}

/* 弹窗样式 */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease;
}

.modal-content {
  background: white;
  border-radius: 20px;
  padding: 30px;
  max-width: 300px;
  width: 90%;
  text-align: center;
  animation: slideUp 0.3s ease;
}

.modal-content img {
  width: 200px;
  height: 200px;
  margin-bottom: 15px;
}

.close-btn {
  margin-top: 20px;
  padding: 10px 30px;
  border: none;
  border-radius: 10px;
  background: #f0f0f0;
  color: #333;
  cursor: pointer;
  transition: all 0.2s;
}

.close-btn:hover {
  background: #667eea;
  color: white;
}

/* 动画 */
@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* 响应式 */
@media (max-width: 480px) {
  .download-container {
    padding: 30px 20px;
  }

  .button-group {
    flex-direction: column;
    gap: 10px;
  }

  .btn-android,
  .btn-ios {
    flex-direction: row;
    justify-content: center;
  }

  .app-info {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  .qrcode-wrapper {
    width: 180px;
    height: 180px;
  }
}
</style>
